import axios from '@/utils/axios';

interface PresignedUploadUrlOptions {
  bucket: string;
  extension: string;
  file_name?: string;
  uri?: string;
}

interface UploadFileOptions {
  file: File;
  presignedUploadUrl: string;
  contentType?: string;
  onProgress?: (pct: number) => void;
  signal?: AbortSignal;
}

class FileUpload {
  static async getPresignedUploadUrl(options: PresignedUploadUrlOptions) {
    const response = await axios.get('/uploads/presigned-url', {
      params: options,
    });
    return response.data;
  }

  static async upload({
    file,
    presignedUploadUrl,
    contentType,
    onProgress,
    signal,
  }: UploadFileOptions) {
    const response = await axios.put(presignedUploadUrl, file, {
      headers: {'Content-Type': contentType || file.type},
      signal,
      onUploadProgress: onProgress
        ? (e) =>
            onProgress(e.total ? Math.round((e.loaded / e.total) * 100) : 0)
        : undefined,
    });
    return response.data;
  }
}

export default FileUpload;
